import Clear from './../layouts/Clear.vue';

export default {
  path: '/user-roles',
  component: Clear,
  children: [
    {
      path: '',
      name: 'user_roles.index',
      component: () => import('@/views/user_roles/index.vue'),
    },
  ],
};
